import { Itinerary, ItineraryState } from 'acscp/store';
import log from 'loglevel';

export function getBookingItinerary(itineraries: ItineraryState, bookingId: string): Itinerary | null {
    const itinerariesForBooking = Object.keys(itineraries)
        .map(id => itineraries[id])
        .filter(i => i.bookingId === bookingId);

    if (itinerariesForBooking.length === 0) {
        return null;
    }

    if (itinerariesForBooking.length > 1) {
        // This should not normally happen (enforced by the state reducer)
        const ids = itinerariesForBooking.map(i => i.id).join(', ');
        log.error(`Found multiple itineraries (${ids}) for booking (${bookingId}).`);
    }

    return itinerariesForBooking[0];
}
